import { useEffect, useState } from "react";

export default function FeaturedDestinationCarousel({
  title = "Featured Destinations",
  subtitle = "Explore Top Cities with Local Experts.",
  items = [],
  onItemClick,
  autoPlay = true,
  autoPlayInterval = 5000,
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!autoPlay || items.length === 0) return;
    const id = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % items.length);
    }, autoPlayInterval);
    return () => clearInterval(id);
  }, [autoPlay, autoPlayInterval, items.length]);

  if (!items.length) return null;

  const activeItem = items[activeIndex] || items[0];

  return (
    <div className="w-full mx-auto">
      <div className=" my-12 text-center space-y-2">
        <h2 className="text-[#61013b] text-[1.9rem] font-semibold">{title}</h2>
        <p className="text-zinc-700 text-[1rem] font-medium">{subtitle}</p>
      </div>

      <div className="relative rounded-2xl overflow-hidden shadow-md bg-black">
        <button
          type="button"
          className="block w-full text-left"
          onClick={() => onItemClick && onItemClick(activeItem, activeIndex)}
        >
          <img
            src={activeItem.src}
            alt={activeItem.alt || activeItem.title || `destination ${activeIndex + 1}`}
            className="w-full h-[360px] sm:h-[440px] md:h-[520px] object-cover"
            loading="lazy"
          />
          {(activeItem.title || activeItem.subtitle || activeItem.location) && (
            <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7 bg-gradient-to-t from-black/70 via-black/30 to-transparent text-white space-y-2">
              {activeItem.location && (
                <p className="text-xs sm:text-sm opacity-90">{activeItem.location}</p>
              )}
              {activeItem.title && (
                <p className="text-2xl sm:text-3xl font-semibold leading-tight">{activeItem.title}</p>
              )}
              {activeItem.subtitle && (
                <p className="text-sm sm:text-base opacity-90 max-w-xl">{activeItem.subtitle}</p>
              )}
              <span className="inline-flex mt-2 px-5 py-2 border border-white/80 rounded text-sm font-semibold hover:bg-white/10 transition-colors">
                Explore
              </span>
            </div>
          )}
        </button>

        {items.length > 1 && (
          <div className="absolute inset-x-0 bottom-4 flex items-center justify-center gap-2">
            {items.map((_, idx) => (
              <button
                key={idx}
                type="button"
                onClick={() => setActiveIndex(idx)}
                className={`transition-all duration-200 ${
                  idx === activeIndex
                    ? "w-6 h-2 bg-white rounded-full"
                    : "w-2 h-2 bg-white/70 rounded-full"
                }`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
